import type { AgreementHistoryEvent } from '../types/agreementTimeline.types';
import { formatHistoryActor } from '../utils/formatHistoryActor';
import {
    formatOccurredAt,
    motorplanPaymentLabel,
    paymentLinkCreatedLabel,
    stateChangeLabel,
    timelineEntryTypeLabel,
    topUpAddedLabel,
} from '../utils/timelineEntryLabels';

interface Props {
    event: AgreementHistoryEvent;
}

const headingFor = (event: AgreementHistoryEvent): string => {
    if (event.kind === 'state_change') return stateChangeLabel(event.stateChange.fromState, event.stateChange.toState);
    if (event.kind === 'note_added') return 'Note added';
    if (event.kind === 'top_up_added') return topUpAddedLabel(event.topUp);

    if (event.kind === 'payment_link_created') return paymentLinkCreatedLabel(event.paymentLink);
    if (event.kind === 'unknown') return timelineEntryTypeLabel(event.entryType);

    return motorplanPaymentLabel(event);
};

/** Records THAT something happened. Note bodies live on the Notes tab and are
 *  never served by this feed. */
export function AgreementHistoryEventItem({ event }: Props) {
    const actor = formatHistoryActor(event);

    return (
        <li className="border-l-2 border-mp-border pl-4">
            <time dateTime={event.occurredAt} className="block text-xs text-mp-muted">
                {formatOccurredAt(event.occurredAt)}
            </time>
            <span className="block text-sm font-medium text-mp-foreground">{headingFor(event)}</span>
            {event.kind === 'state_change' && event.stateChange.reason && (
                <p className="text-sm text-mp-muted">{event.stateChange.reason}</p>
            )}
            {actor && <p className="text-xs text-mp-muted">{actor}</p>}
        </li>
    );
}
